import { Stack } from "@mui/material";
import { getEnvironmentVariableByName } from "../../utils";
import { HImage } from "../HImage";

const path = getEnvironmentVariableByName("FLAGS_BLOB_STORE_PATH");
const ext = getEnvironmentVariableByName("FLAGS_EXTENSION");

type THFlag = {
  isoCode: string;
  width?: number;
  height?: number;
};

export const HFlag = ({ isoCode, width = 20, height = 16 }: THFlag) => {
  return (
    <Stack
      width={width}
      height={height}
      justifyContent="center"
      alignItems="center"
      style={{
        borderRadius: "4px",
        overflow: "hidden",
      }}
    >
      <HImage
        loading="lazy"
        alt={`immagine bandiera ${isoCode}`}
        width={width}
        src={`${path}${isoCode.toLowerCase()}${ext}`}
      />
    </Stack>
  );
};
